import styled from 'styled-components';
import React from 'react';
import _ from 'lodash';
import * as api from '~/myApi'
import { copyTextToClipboard } from '~/utils/copy'
import Pagination from '@mui/material/Pagination';
import Switch from '@mui/material/Switch';
import Table from '~/component/common/Table'
import { ColumnsType } from 'rc-table/lib/interface'
import { Loader } from '~/component/common/Loader';

const PaginationContainer = styled(Pagination)`
  margin: 16px 0;
`

interface SurveyTableProps {
  items?: api.TypesSurveyPartialInfo[];
  total?: number
  page?: number
  loading?: boolean
  changePageNum?: (i: number) => void
  detailOnClick: (id: string) => void;
  editOnClick: (id: string) => void;
  copyComplate: (id: string) => void;
  changeStatusConfirmModal?: (survey: api.TypesSurveyFullInfo) => void
}

export const SurveyTable: React.FC<SurveyTableProps> = (props) => {

  if (props.items?.length === 0) return <></>

  const columns: ColumnsType<api.TypesSurveyPartialInfo> = [
    {
      key: 'id',
      dataIndex: 'id',
      title: 'ID',
      width: 130,
      onCell: (record) => ({
        onClick() {
          if(copyTextToClipboard(record.id!)) {
            props.copyComplate(record.id!)
          }
        },
      }),
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: 'サーベイ名',
      onCell: (record) => ({
        onClick() {
          props.editOnClick(record.id!)
        },
      }),
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: '配信',
      width: 70,
      render: (data, record) => <Switch checked={record.status === api.EnumsSurveyStatus.SURVEY_STATUS_ON} />,
      onCell: (record) => ({
        onClick(e) {
          props.changeStatusConfirmModal && props.changeStatusConfirmModal(record)
        },
      }),
    },
    {
      key: 'targetCollectionNum',
      dataIndex: 'targetCollectionNum',
      title: '回収率',
      align: 'right',
      width: 200,
      render: (data, record) => record.collectedNum && record.targetCollectionNum ? `${Math.ceil(record.collectedNum / record.targetCollectionNum * 100)}%` : '-',
      onCell: (record) => ({
        onClick(e) {
          props.editOnClick(record.id!)
        },
      }),
    },
  ]

  if(props.loading) {
    return <Loader />
  }

  return (
    <>
      <Table {...{
        onRow: (record: api.TypesSurveyPartialInfo, index: number) => ({
          onClick: (e: React.MouseEvent<HTMLTableCellElement>) => {},
        }),
        rowKey: 'id',
        columns: columns,
        scroll: false,
        data: props.items!
      }} />

      <PaginationContainer
        page={props.page || 1}
        count={Math.ceil((props.total || 0) / 10)}
        color="primary" onChange={(e, num) => { props.changePageNum!(num) }}
      />
    </>
  );
};

export default SurveyTable